// import { AbiItem } from 'web3-utils'
import poolsConfig from 'config/constants/pools'
// import masterChefABI from 'config/abi/masterchef.json'
import sousChefABI from 'config/abi/sousChef.json'
import sousChefV2ABI from 'config/abi/sousChefV2.json'
import erc20ABI from 'config/abi/erc20.json'
import { QuoteToken } from 'config/constants/types'
import multicall from 'utils/multicall'
// import { getMasterChefAddress } from 'utils/addressHelpers'
import { getWeb3 } from 'utils/web3'
import BigNumber from 'bignumber.js'

const CHAIN_ID = process.env.REACT_APP_CHAIN_ID

// Pool 0, Cake / Cake is a different kind of contract (master chef)
// BNB pools use the native BNB token (wrapping ? unwrapping is done at the contract level)
const nonBnbPools = poolsConfig.filter((p) => p.stakingTokenName !== QuoteToken.BNB)
const bnbPools = poolsConfig.filter((p) => p.stakingTokenName === QuoteToken.BNB)
const nonMasterPools = poolsConfig.filter((p) => p.sousId !== 0)
const nonMasterPoolsV2 = nonMasterPools.filter((p) => p.sousId !== 2)
const web3 = getWeb3()
// const masterChefContract = new web3.eth.Contract((masterChefABI as unknown) as AbiItem, getMasterChefAddress())

export const fetchPoolsAllowance = async (account) => {
  const calls = nonBnbPools.map((p) => ({
    address: p.stakingTokenAddress,
    name: 'allowance',
    params: [account, p.contractAddress[CHAIN_ID]],
  }))

  const allowances = await multicall(erc20ABI, calls)
  return nonBnbPools.reduce(
    (acc, pool, index) => ({ ...acc, [pool.sousId]: new BigNumber(allowances[index]).toJSON() }),
    {},
  )
}

export const fetchUserBalances = async (account) => {
  // Non BNB pools
  const calls = nonBnbPools.map((p) => ({
    address: p.stakingTokenAddress,
    name: 'balanceOf',
    params: [account],
  }))
  const tokenBalancesRaw = await multicall(erc20ABI, calls)
  const tokenBalances = nonBnbPools.reduce(
    (acc, pool, index) => ({ ...acc, [pool.sousId]: new BigNumber(tokenBalancesRaw[index]).toJSON() }),
    {},
  )

  // BNB pools
  const bnbBalance = await web3.eth.getBalance(account)
  const bnbBalances = bnbPools.reduce(
    (acc, pool) => ({ ...acc, [pool.sousId]: new BigNumber(bnbBalance).toJSON() }),
    {},
  )

  return { ...tokenBalances, ...bnbBalances }
}

export const fetchUserStakeBalances = async (account) => {
  const calls = nonMasterPools.map((p) => ({
    address: p.contractAddress[CHAIN_ID],
    name: 'userInfo',
    params: [account],
  }))
  const userInfo = await multicall(sousChefABI, calls)
  const stakedBalances = nonMasterPools.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: new BigNumber(userInfo[index].amount._hex).toJSON(),
    }),
    {},
  )

  // Cake / Cake pool
  // const { amount: masterPoolAmount } = await masterChefContract.methods.userInfo('0', account).call()

  return { ...stakedBalances }
}

export const fetchUserNextHarvestUntils = async (account) => {
  const calls = nonMasterPools.map((p) => ({
    address: p.contractAddress[CHAIN_ID],
    name: 'userInfo',
    params: [account],
  }))
  const userInfo = await multicall(sousChefABI, calls)

  const nextHarvestUntils = nonMasterPools.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: new BigNumber(userInfo[index].nextHarvestUntil._hex).toJSON(),
    }),
    {},
  )

  // Cake / Cake pool
  // const { amount: masterPoolAmount } = await masterChefContract.methods.userInfo('0', account).call()

  return { ...nextHarvestUntils }
}

export const fetchUserPendingRewards = async (account) => {
  const calls = nonMasterPools.map((p) => ({
    address: p.contractAddress[CHAIN_ID],
    name: 'pendingReward',
    params: [account],
  }))
  const res = await multicall(sousChefABI, calls)
  const pendingRewards = nonMasterPools.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: new BigNumber(res[index]).toJSON(),
    }),
    {},
  )

  // Cake / Cake pool
  // const pendingReward = await masterChefContract.methods.pendingSandMan('0', account).call()

  return { ...pendingRewards }
}

export const fetchUserCanHarvests = async (account) => {
  const calls = nonMasterPools.map((p) => ({
    address: p.contractAddress[CHAIN_ID],
    name: 'canHarvest',
    params: [account],
  }))
  const res = await multicall(sousChefABI, calls)
  const canHarvests = nonMasterPools.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: res[index][0],
    }),
    {},
  )

  // Cake / Cake pool
  // const canHarvest = await masterChefContract.methods.pendingSandMan('0', account).call()

  return { ...canHarvests }
}

// V2

export const fetchUserIsPlayingNow = async (account) => {
  const calls = nonMasterPoolsV2.map((p) => ({
    address: p.contractAddress[CHAIN_ID],
    name: 'userIsPlayingNow',
    params: [account],
  }))

  const res = await multicall(sousChefV2ABI, calls)

  const userIsPlayingNow = nonMasterPoolsV2.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: res[index][0],
    }),
    {},
  )

  return { ...userIsPlayingNow }
}

export const fetchCanClaimHarvest = async (account) => {
  const calls = nonMasterPoolsV2.map((p) => ({
    address: p.contractAddress[CHAIN_ID],
    name: 'canClaimHarvest',
    params: [account],
  }))

  const res = await multicall(sousChefV2ABI, calls)

  const canClaimHarvests = nonMasterPoolsV2.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: res[index][0],
    }),
    {},
  )

  return { ...canClaimHarvests }
}

export const fetchUserRoundNumbers = async (account) => {
  const calls = nonMasterPoolsV2.map((p) => ({
    address: p.contractAddress[CHAIN_ID],
    name: 'ledger',
    params: [account],
  }))

  const res = await multicall(sousChefV2ABI, calls)

  const ledger = nonMasterPoolsV2.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: new BigNumber(res[index].roundNumber._hex).toJSON(),
    }),
    {},
  )

  return { ...ledger }
}

export const fetchUserLastRoundHarvets = async (account) => {
  const calls = nonMasterPoolsV2.map((p) => ({
    address: p.contractAddress[CHAIN_ID],
    name: 'ledger',
    params: [account],
  }))

  const res = await multicall(sousChefV2ABI, calls)

  const ledger = nonMasterPoolsV2.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: new BigNumber(res[index].lastRoundHarvest).toJSON(),
        // position: res[index].position,
    }),
    {},
  )

  return { ...ledger }
}

export const fetchUserPositions = async (account) => {
  const calls = nonMasterPoolsV2.map((p) => ({
    address: p.contractAddress[CHAIN_ID],
    name: 'ledger',
    params: [account],
  }))

  const res = await multicall(sousChefV2ABI, calls)

  const ledger = nonMasterPoolsV2.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: res[index].position,
    }),
    {},
  )

  return { ...ledger }
}
